<vivest-tag
  type="status"
  variant="neutral"
  class="instituto-status-tag"
  [style.--status-cor]="cor().cor"
  [style.--status-texto]="cor().texto"
  >{{ status() ?? '—' }}</vivest-tag
>
